<script setup lang="ts">
import { getSource, DataSourceParams, DataSource } from '~/stores/static/dataSources'

const props = defineProps<{ sourceData: DataSourceParams[] }>()

const sources = computed<DataSource[]>(() => {
  return props.sourceData.map((sourceData) => getSource(sourceData.identifier, sourceData.year))
})
</script>

<template>
  <div v-if="sources" class="data-source">
    <span>Källa: </span>
    <span v-for="(source, index) in sources" :key="source?.name">
      <span v-if="source && source?.url">
        <a :href="source?.url" target="_blank" :alt="source?.name">{{ source.name }}</a>
        <span v-if="index < sources.length -1">,</span>
      </span>
      <span v-else-if="source">{{ source.name }}</span>
    </span>
  </div>
</template>

<style lang="scss">
@import 'App.scss';
.data-source {
  font-size: 0.875rem;
  color: #777;
  margin: 1rem 0;

  @include desktop-up() {
    display: flex;
    flex-wrap: wrap;
    gap: 0.5rem;
    row-gap: 0.25rem;
  }
}
</style>
